// Kunden deaktiverer sin profil (Mine bookinger › Mine oplysninger). Intet slettes: oplysninger og historik bliver hos
// virksomheden (vil kunden have dem slettet, kontakter hun os – kontoret har "Slet kundens oplysninger").
//  • Kan kun, når kunden ikke har kommende aktive bookinger (de skal aflyses først – aldrig automatisk).
//  • Deaktiveret: kunden logges ud, login-links og sessioner ugyldiggøres, markedsføring slås fra (som en afmelding), og
//    automatiseringerne sender intet til kunden (hindring i automationMotor.ts). Ingen kvitteringsmail.
//  • Tilbage: kunden booker igen online med samme e-mail/mobil (profilen genaktiveres automatisk), eller kontoret genaktiverer.
// Samme regler i testversionen (DemoApi) og i databasen (20261029880000_deaktiver.sql).
import { datoTekst, iDag } from './dato.ts';

export type DeaktiveretAf = 'kunde' | 'kontor';

/** Automatiseringernes grund til at springe beskeden over. */
export const DEAKTIVERET = 'Kunden har deaktiveret sin profil';

/** Bookingstatusser, der skal aflyses, før profilen kan deaktiveres. Uden tid (gavekort, mangler tid) tæller altid med. */
const AKTIVE = ['afventer', 'godkendt', 'i_gang', 'skal_rykkes'];
const UDEN_TID = ['afventer_dato', 'mangler_tid'];

/** Kundens kommende aktive bookinger – dem, der står i vejen for at deaktivere profilen. */
export function kommendeAktive<T extends { dato: string; status: string }>(bs: T[], idag = iDag()): T[] {
  return bs.filter((b) => UDEN_TID.includes(b.status) || (AKTIVE.includes(b.status) && (!b.dato || b.dato >= idag)));
}

export const KOMMENDE_FEJL = 'Du har kommende bookinger. Aflys dem først – eller ring til os – så kan du deaktivere din profil.';

/** "Deaktiveret 29. oktober af kunden" – null, når profilen er aktiv. */
export function deaktiveretTekst(k: { deaktiveret?: string | null; deaktiveret_af?: DeaktiveretAf | null }): string | null {
  if (!k.deaktiveret) return null;
  return `Deaktiveret ${datoTekst(k.deaktiveret.slice(0, 10), false)} af ${k.deaktiveret_af === 'kontor' ? 'kontoret' : 'kunden'}`;
}

/** Den venlige besked, når en deaktiveret kunde prøver at logge ind (kode, link eller adgangskode). */
export function deaktiveretLogin(firma: string, telefon?: string | null): string {
  return `Din profil hos ${firma || 'os'} er deaktiveret. Book en ny tid med samme e-mail, så åbner den igen` +
    (telefon ? ` – eller ring på ${telefon}.` : ' – eller kontakt os.');
}
